import { Link } from 'react-router-dom';

export default function FinalCTASection() {
  return (
    <section className="relative py-16 sm:py-24 lg:py-32 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/95450e033eea5f7c6a21452792ad73c0.jpg"
          alt="Sunset cockpit view"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/70 via-[#0A1628]/80 to-[#0A1628]/90"></div>
      </div>

      {/* HUD-style corner elements */}
      <div className="absolute top-4 left-4 sm:top-8 sm:left-8 w-8 h-8 sm:w-16 sm:h-16 border-l-2 border-t-2 border-[#00FFD1]/30"></div>
      <div className="absolute top-4 right-4 sm:top-8 sm:right-8 w-8 h-8 sm:w-16 sm:h-16 border-r-2 border-t-2 border-[#00FFD1]/30"></div>
      <div className="absolute bottom-4 left-4 sm:bottom-8 sm:left-8 w-8 h-8 sm:w-16 sm:h-16 border-l-2 border-b-2 border-[#00FFD1]/30"></div>
      <div className="absolute bottom-4 right-4 sm:bottom-8 sm:right-8 w-8 h-8 sm:w-16 sm:h-16 border-r-2 border-b-2 border-[#00FFD1]/30"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">Fly with a smarter right seat.</h2>
        <p className="text-lg sm:text-2xl text-[#00FFD1] mb-8 sm:mb-12 leading-relaxed">
          Join pilots and instructors using WingmanFix to build safer, sharper flying habits.
        </p>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
          <Link
            to="/waitlist"
            className="bg-[#00A3E0] hover:bg-[#0088BB] text-white px-6 sm:px-10 py-3 sm:py-5 rounded-lg transition-all font-bold text-base sm:text-lg shadow-2xl hover:shadow-[#00A3E0]/50 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Download WingmanFix
          </Link>
          <Link
            to="/waitlist"
            className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white/20 px-6 sm:px-10 py-3 sm:py-5 rounded-lg transition-all font-bold text-base sm:text-lg cursor-pointer whitespace-nowrap"
          >
            Join Early Access
          </Link>
        </div>
      </div>
    </section>
  );
}